import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TicketsManager from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import TicketsEmptyState from "../../components/TicketsEmptyState";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1,
    // backgroundColor: "#eee",
    padding: theme.spacing(1),
    height: `calc(100% - 58px)`,
    overflowY: "hidden",
  },

  chatPapper: {
    display: "flex",
    height: "100%",
    width: "100%",
  },
  contactsWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
  },
  messagesWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
  },
}));

const TicketsCustom = () => {
  const classes = useStyles();
  const { ticketId } = useParams();
  const [counts, setCounts] = useState({ open: 0, pending: 0 });
  const [tabRequest, setTabRequest] = useState(null);

  const handleCountsChange = useCallback((next) => {
    setCounts((prev) => ({ ...prev, ...next }));
  }, []);

  return (
    <div className={classes.chatContainer}>
      <div className={classes.chatPapper}>
        <Grid container spacing={0} style={{ width: "100%", flex: 1 }}>
          <Grid item xs={4} className={classes.contactsWrapper} style={{ minWidth: 340 }}>
            <TicketsManager
              onCountsChange={handleCountsChange}
              tabRequest={tabRequest}
            />
          </Grid>
          <Grid item xs={8} className={classes.messagesWrapper}>
            {ticketId ? (
              <>
                <Ticket />
              </>
            ) : (
              <TicketsEmptyState
                openCount={counts.open}
                pendingCount={counts.pending}
                onSelectTab={(tab) => setTabRequest({ tab, at: Date.now() })}
              />
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default TicketsCustom;
